module.exports = __webpack_public_path__ + "img/palabras-peace-pencil-preview.1da76282.png";